/* [Modified by Codex at 2026-10-26] 保留旧选色接口并让Custom Color与尺寸共用购买校验 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.onSubmitBound = this.onSubmitHandler.bind(this);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonSpinner = this.submitButton.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.customSizeEnabled = this.hasAttribute('data-custom-size-enabled') && this.dataset.customSizeEnabled !== 'false';
        this.moreColorEnabled = this.dataset.moreColorEnabled === 'true';
        this.purchaseGateEnabled = this.customSizeEnabled || this.moreColorEnabled;
        if (this.purchaseGateEnabled) {
          this.commerceDisabled = this.dataset.commerceDisabled !== 'false';
          this.customSizeReady = !this.customSizeEnabled;
          this.customSizeActive = false;
          this.customSizeValid = false;
          this.moreColorReady = !this.moreColorEnabled;
          this.moreColorActive = false;
          this.moreColorValid = false;
          this.submissionBusy = false;
          this.customSizeMessage = this.querySelector('[data-custom-size-purchase-message]')?.textContent.trim() || '';
          this.moreColorMessage = this.dataset.moreColorRequired || '';
          this.applyCustomSizeGate();
        }
      }

      connectedCallback() {
        this.form.addEventListener('submit', this.onSubmitBound);
      }

      disconnectedCallback() {
        this.form.removeEventListener('submit', this.onSubmitBound);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.purchaseGateEnabled) {
          let prepared = true;
          const productInfo = this.closest('product-info');
          for (const [enabled, selector] of [
            [this.customSizeEnabled, 'product-custom-size'],
            [this.moreColorEnabled, 'product-more-color'],
          ]) {
            if (!enabled) continue;
            const component = Array.from(productInfo?.querySelectorAll(selector) || [])
              .find((element) => element.dataset.formId === this.form.getAttribute('id') &&
                (!element.closest('variant-selects') || element.closest('variant-selects') === productInfo.querySelector('variant-selects')));
            if (component?.prepareSubmission?.({ report: true }) !== true) prepared = false;
          }
          if (!prepared || !this.customSizeReady || !this.moreColorReady || this.commerceDisabled || this.submissionBusy || this.error ||
            (this.customSizeActive && !this.customSizeValid) ||
            (this.moreColorActive && !this.moreColorValid) || this.submitButton.disabled) return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        if (this.purchaseGateEnabled) {
          this.submissionBusy = true;
          this.applyCustomSizeGate();
        }
        this.submitButton.classList.add('loading');
        this.submitButtonSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (this.purchaseGateEnabled) {
                if (String(this.variantIdInput.value) !== String(formData.get('id'))) return;
                this.commerceDisabled = true;
                this.error = true;
                this.applyCustomSizeGate();
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.purchaseGateEnabled) {
              this.submissionBusy = false;
              this.applyCustomSizeGate();
            } else if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.submitButtonSpinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.purchaseGateEnabled) {
          this.commerceDisabled = Boolean(disable);
          this.error = false;
          if (disable) {
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
          this.applyCustomSizeGate();
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      setCustomSizeState({ active, valid, message = '' }) {
        if (!this.customSizeEnabled) return;
        this.customSizeReady = true;
        this.customSizeActive = Boolean(active);
        this.customSizeValid = valid === true;
        this.customSizeMessage = message;
        this.applyCustomSizeGate();
      }

      setMoreColorState({ active, valid, message = '' }) {
        if (!this.moreColorEnabled) return;
        this.moreColorReady = true;
        this.moreColorActive = Boolean(active);
        this.moreColorValid = valid === true;
        this.moreColorMessage = message;
        this.applyCustomSizeGate();
      }

      setCustomColorState(state) {
        return this.setMoreColorState(state);
      }

      applyCustomSizeGate() {
        if (!this.purchaseGateEnabled) return;
        const customDisabled = this.customSizeEnabled && (!this.customSizeReady || (this.customSizeActive && !this.customSizeValid));
        const colorDisabled = this.moreColorEnabled && (!this.moreColorReady || (this.moreColorActive && !this.moreColorValid));
        const disabled = this.commerceDisabled || customDisabled || colorDisabled || this.submissionBusy || Boolean(this.error);
        this.submitButton.toggleAttribute('disabled', disabled);
        if (disabled) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }

        const propertyFields = this.form.querySelector('[data-custom-size-properties]');
        if (propertyFields) {
          propertyFields.disabled = !this.customSizeReady || !this.customSizeActive || !this.customSizeValid;
          propertyFields.querySelectorAll('input').forEach((input) => {
            input.disabled = propertyFields.disabled;
          });
        }

        const colorProperty = this.form.querySelector('[data-more-color-property]');
        if (colorProperty) colorProperty.disabled = !this.moreColorReady || !this.moreColorActive || !this.moreColorValid;

        const payment = this.querySelector('[data-purchase-payment], [data-custom-size-payment]');
        if (payment) {
          payment.hidden = disabled;
          payment.inert = disabled;
          payment.toggleAttribute('inert', disabled);
        }
        const placeholder = this.querySelector('[data-purchase-buy-now-placeholder], [data-custom-size-buy-now-placeholder]');
        if (placeholder) {
          placeholder.hidden = !disabled;
          placeholder.disabled = true;
        }
        const message = this.querySelector('[data-purchase-message], [data-custom-size-purchase-message]');
        if (message) {
          message.textContent = [colorDisabled ? this.moreColorMessage : '', customDisabled ? this.customSizeMessage : '']
            .filter(Boolean).join(' ');
          message.hidden = !message.textContent;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
/* [End] */
